import { render, staticRenderFns } from "./document-menu.vue?vue&type=template&id=46e1076a&%40click%3Aoutside=closeThisMenu&"
import script from "./document-menu.vue?vue&type=script&lang=js&"
export * from "./document-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports